function setupTermsCheckboxValidation() {
    const cartSubmitButton = document.querySelector('[data-cart-form-submit]');
    const cartTermsInput = document.querySelector('[data-terms-cart]');
    const cartTermsText = document.querySelector('[data-terms-text]');

    if (cartSubmitButton) {
        cartSubmitButton.addEventListener('mouseenter', () => {
            if(!cartTermsInput.checked) {
                cartTermsText.style.opacity = "1";
            }
        });
        cartSubmitButton.addEventListener('mouseleave', () => {
            if(!cartTermsInput.checked) {
                cartTermsText.style.opacity = "0";
            }
        });
    }

    if(cartTermsInput) {
        if(!cartTermsInput.checked) {
            cartSubmitButton.setAttribute('disabled', true);
        }

        cartTermsInput.addEventListener('change', function() {
            if (cartTermsInput.checked) {
                cartSubmitButton.removeAttribute('disabled');
                cartSubmitButton.classList.remove('disabled');
            } else {
                cartSubmitButton.setAttribute('disabled', true);

            }
        });
    }
}

window.setupTermsCheckboxValidation = setupTermsCheckboxValidation;